import React from "react";
import "../styles/UsermanageRolesandPermisions.css";
import { useState, useEffect, useRef } from "react";
import ThreeDots from "../icons/BusinessHub/ThreeDots";
import { useNavigate } from "react-router-dom";
import RemoveUser from "../icons/BusinessHub/RemoveUserIcon";
import EditDetails from "../icons/BusinessHub/EditDetails";
import BinIcon from "../icons/BusinessHub/BinIcon";
import { useLocation } from "react-router-dom";
import Utils from "../utils/Utils";
import userController from "../controllers/userController";
import { userService } from "../services/userService";
import WarningIcon from "../icons/BusinessHub/WarningIcon";
import { toast } from "react-toastify";

function UsermanageRolesandPermisions() {
  const app = 4;
  const [jwt, setjwt] = useState("");
  const navigate = useNavigate();
  const [companyID, setCompanyID] = useState("");
  const [actiondiv, setactiondiv] = useState(false);
  const [data, setData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const popupRef = useRef(null);
  const [roleId, setroleid] = useState("");
  const [assigned, setAssigned] = useState(false); //def false

  const handleEditClick = (
    companyID,
    roleID,
    roleName,
    roleDescription,
    permissionIDs,
  ) => {
    navigate("/edit-user-roles", {
      state: {
        companyID,
        roleID,
        roleName,
        roleDescription,
        permissionIDs,
        jwt,
      },
    });
  };
  const handleactiondiv = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };
  useEffect(() => {
    setjwt(userService.getUser());
  }, []);

  useEffect(() => {
    if (!jwt) return;

    const Pjwt = Utils.parseJwt(jwt);
    // const companyID = Object.keys(Pjwt.userDetails)[0];
    const companyID = userService.getCompID();
    setCompanyID(companyID);
    getRoles(companyID);
  }, [jwt]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setOpenIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getRoles = async (companyID) => {
    const getRole = await userController.GetRoles({
      jwt,
      application: app,
      companyId: companyID,
    });
    setData(getRole.data || []);
  };

  const removeRole = async () => {
    try {
      const deleteRole = await userController.deleteRole({
        deleteRoleRequest: {
          companyId: companyID,
          roleId,
        },
        jwt: jwt,
      });
      if (Utils.isSuccessResponse(deleteRole)) {
        toast.success("Role deleted successfully");
        setactiondiv(false);
        getRoles(companyID);
        return;
      }
      if (deleteRole !== true) {
        toast.error("Role is assigned to users and cannot be deleted");
        setAssigned(true);
      }
    } catch (error) {
      console.log("error delete");
      setAssigned(true);
    }
  };

  return (
    <div className="user-role-display-table">
      <div className="user-role-table">
        {actiondiv && (
          <div className="remove-roll-popup-container">
            <div
              className="remove-roll-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              {assigned ? (
                <div className="remove-roll-deletion-popup-warning">
                  <div className="warning-roll-icon">
                    <WarningIcon />
                  </div>
                  <div className="delete-roll-warning-text">
                    <div className="delete-roll-warning-title">Warning</div>
                    <div className="delete-roll-warning-description">
                      This role cannot be deleted because one or more users are
                      currently assigned to it. Please reassign or remove these
                      users before deleting the role.
                    </div>
                  </div>
                  <div
                    className="cancel-warning-roll-button"
                    onClick={() => {
                      setactiondiv(false);
                      setAssigned(false);
                    }}
                  >
                    okay
                  </div>
                </div>
              ) : (
                <div className="remove-roll-deletion-popup-content">
                  <div className="delete-roll-icon">
                    <BinIcon />
                  </div>
                  <div className="delete-roll-text">
                    <div className="delete-roll-title">Delete Role</div>
                    <div className="delete-roll-description">
                      Are you sure you want to delete this role. This action
                      cannot be undone. This role will be deleted forever.
                    </div>
                  </div>
                  <div className="delete-roll-buttons">
                    <div
                      className="delete-roll-action-button"
                      onClick={() => removeRole()}
                    >
                      Delete
                    </div>

                    <div
                      className="cancel-delete-roll-button"
                      onClick={() => setactiondiv(false)}
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="roles-table-header-row">
          <div className="cell-content-role">
            <div className="cell-content-role-container">Roles</div>
            <div className="cell-content-desc">Description</div>
          </div>
          <div className="role-cell-content">Actions</div>
        </div>
        {data.map((item, index) => (
          <div className="role-table-row" key={item.roleID}>
            <div className="cell-content-role">
              <div className="cell-content-role-container">{item.roleName}</div>{" "}
              <div className="cell-content-desc">{item.roleDescription}</div>
            </div>
            <div className="role-cell-content">
              <div
                className={
                  item.defaultRole
                    ? "roles-more-actions-icon-defualt"
                    : "roles-more-actions-icon"
                }
                onClick={() => handleactiondiv(index)}
              >
                <ThreeDots />
              </div>
              {/********************************************* */}
              <div
                className={
                  item.defaultRole
                    ? "roles-more-actions-icon-defualt-res"
                    : "roles-more-actions-icon-res"
                }
              >
                <div
                  className="edit-employess-data-action-botton"
                  onClick={() => {
                    handleEditClick(
                      companyID,
                      item.roleID,
                      item.roleName,
                      item.roleDescription,
                      item.permissions.map((p) => p.permissionID),
                    );
                  }}
                >
                  <EditDetails stroke="#4072C8" />
                </div>
                <div
                  className="delete-employess-data-action-botton"
                  onClick={() => {
                    setactiondiv(true);
                    setOpenIndex(null);
                    setroleid(item.roleID);
                  }}
                >
                  <BinIcon
                    showOuterCircle={false}
                    showInnerCircle={false}
                    width="22.5px"
                    height="24px"
                  />
                </div>
              </div>
              {/********************************************* */}
              {openIndex === index && (
                <div ref={popupRef} className="roles-actions-popup">
                  <div
                    className="roles-popup-rows"
                    onClick={() => {
                      handleEditClick(
                        companyID,
                        item.roleID,
                        item.roleName,
                        item.roleDescription,
                        item.permissions.map((p) => p.permissionID),
                      );
                    }}
                  >
                    <div className="roles-popup-rows-icon">
                      <EditDetails />
                    </div>
                    <div className="roles-user-edit-details-text">
                      Edit Details
                    </div>
                  </div>
                  <div
                    className="roles-popup-rows-bottom"
                    onClick={() => {
                      setactiondiv(true);
                      setOpenIndex(null);
                      setroleid(item.roleID);
                    }}
                  >
                    <div className="roles-popup-rows-icon">
                      <RemoveUser />
                    </div>
                    <div className="roles-user-remove-user-text">
                      Remove Role
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UsermanageRolesandPermisions;
